"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { EvoluContext } from "./EvoluContext.js";
export const EvoluProvider = ({ children, value, }) => (_jsx(EvoluContext.Provider, { value: value, children: children }));
